'use client';

import { create } from 'zustand';

type PulseState = {
  ids: string[] | null;
  setIds: (ids: string[] | null) => void;
  hoverIds: string[] | null;
  setHoverIds: (ids: string[] | null) => void;
};

export const usePulseStore = create<PulseState>()((set) => ({
  ids: null,
  setIds: (ids) => set({ ids }),
  hoverIds: null,
  setHoverIds: (hoverIds) => set({ hoverIds }),
}));
